export interface IEventMap {
  [key: string]: string;
}

/**
 * 云端录制状态
 * 
 * @param IDLE 本地录制未开始或录制结束
 * @param ACTING 本地录制进行中
 * @param PAUSE_BY_OTHERS 录制被暂停 这里有两种情况 1. 本地正在录制中，被会控暂停 2. 其他人正在录制中，被会控暂停录制
 * @param IDLE_BY_OTHERS 录制结束 两种情况 1. 本地正在录制中或者暂停中，被会控结束录制 2. 其他人录制结束
 * @param ACTING_BY_OTHERS 录制进行中 两种情况 1. 本地录制被暂停后又被恢复录制 2. 其他人录制进行中
 * @param DISABLE 录制功能被禁用，无权限
 */
export enum RecordStatus {
  IDLE,
  ACTING,
  PAUSE_BY_OTHERS,
  IDLE_BY_OTHERS,
  ACTING_BY_OTHERS,
  DISABLE,
}

/**
 * 布局模式
 *
 * @param AUTO 自动布局
 * @param CUSTOM 自定义布局
 */
export enum LayoutModel {
  AUTO = "AUTO",
  CUSTOM = "CUSTOM",
}

/**
 * 显示远端人脸信息 模式
 *
 * @param Detect 扫描模式
 * @param EletronicBadge 铭牌模式
 */
export enum FaceType {
  Detect = "Detect",
  EletronicBadge = "EletronicBadge",
}

/**
 * 布局分类 sdk内部使用
 * @param CONTENT 存在content
 * @param NORMAL 不存在content
 */
export enum LayoutMode {
  "CONTENT" = "CONTENT",
  "NORMAL" = "NORMAL",
}

/**
 * layout模板模式
 */
export enum TemplateModel {
  "SPEAKER" = "SPEAKER",
  "GALLERY" = "GALLERY",
  "MULTI_PIC_CONTENT_HIGH_PRIORITY" = "MULTI_PIC_CONTENT_HIGH_PRIORITY",
  "MULTI_PIC_ACTIVE_HIGH_PRIORITY" = "MULTI_PIC_ACTIVE_HIGH_PRIORITY",
  "TWO_PIC_PIP" = "TWO_PIC_PIP",
  "CONTENT_ONLY" = "CONTENT_ONLY",
  "TWO_PIC_SYMMETRIC" = "TWO_PIC_SYMMETRIC",
}

/**
 * 模板中画面角色类型
 */
export enum TempValType {
  CONTENT = "CONTENT",
  P1 = "P1",
  LOCAL = "LOCAL",
}

/**
 * 视频流状态
 */
export enum VideoState {
  Observing,
  VideoMute,
  Requesting,
  NoBandwidth,
  NoDecoder,
  Received,
  Telephone,
  AudioOnly,
  Idle,
}

/**
 * 上报video画面状态数据 视频状态
 */
export enum VideoStatus {
  Normal,
  LowAsLocalBw,
  LowAsLocalHardware,
  LowAsRemote,
  NetworkError,
  LocalWifiIssue,
}
/**
 * 入会模式
 *
 * @param AudioVideo 语音视频模式
 * @param AudioOnly  语音模式
 */
export enum CallMode {
  "AudioVideo" = "AudioVideo",
  "AudioOnly" = "AudioOnly",
}

/**
 * 遥控摄像头指令
 */
export enum SDKFECCCommand {
  FECC_TURN_LEFT /* 连续左转 */,
  FECC_STEP_LEFT /* 向左步进 */,
  FECC_TURN_RIGHT /* 连续右转 */,
  FECC_STEP_RIGHT /* 向右步进 */,
  FECC_TURN_STOP /* 水平转动停止。停止 FECC_TURN_ */,
  TILT_CAMERA_TURN_UP /* 向上抬起 */,
  TILT_CAMERA_STEP_UP,
  TILT_CAMERA_TURN_DOWN /* 向下低头 */,
  TILT_CAMERA_STEP_DOWN,
  TILT_CAMERA_TURN_STOP,
  FECC_ZOOM_IN /* 放大 */,
  FECC_ZOOM_OUT /* 缩小 */,
  FECC_STEP_ZOOM_IN,
  FECC_STEP_ZOOM_OUT,
  FECC_ZOOM_TURN_STOP,
  MOVE_LEFT_TURN,
  MOVE_LEFT_STEP,
  MOVE_RIGHT_TURN,
  MOVE_RIGHT_STEP,
  MOVE_UP_TURN,
  MOVE_UP_STEP,
  MOVE_DOWN_TURN,
  MOVE_DOWN_STEP,
  MOVE_STOP,
  FECC_UNKNOWN,
}

/**
 * 互动工具业务状态：开始 结束 发布结果 关闭结果
 */
export enum EventType {
  START,
  STOP,
  PUBLISH,
  RESULT_CLOSE,
}

/**
 * 互动工具业务类型：签到 答题 投票 评估
 */
export enum ProcessType {
  NONE,
  SIGN_IN,
  ANSWER,
  VOTE,
  EVALUATION,
}

/**
 * 设备管理枚举
 */
export enum DeviceTypeMap {
  camera,
  microphone,
  speaker,
}

/**
 * 设备管理key
 */
export enum DeviceTypeKey {
  camera = "camera",
  microphone = "microphone",
  speaker = "speaker",
}

/**
 * 同传字幕语言类型
 *
 * @param NONE 0 - 关闭字幕
 * @param CHINESE 1 简体中文
 * @param ENGLISH 2 英语
 */
export enum LanguageType {
  NONE,
  CHINESE,
  ENGLISH,
}

/**
 * 终端类型
 */
export enum TerminalType {
  UNKNOWN = -1,
  SOFT = 0,
  HARD,
  BROWSER,
  TEL,
  RECORD,
  DESKTOP,
  H323GW,
  BRUCE,
  TVBOX,
  CONFNO,
  SHUTTLE,
  WECHAT,
  PSTNGW,
  TRANSEP,
  WEBRTC,
}

/**
 * 国际化语言类型
 */
export enum Locale {
  zh_CN = "zh_CN",
  en_US = "en_US",
  zh_TW = "zh_TW",
}

/**
 * 共享流模式
 * 
 * @param NONE 无
 * @param AUDIO 音频
 * @param VIDEO 视频
 * @param BOTH 音视频
 */
export enum ContentStreamMode {
  NONE = 0,
  AUDIO = 1 << 0,
  VIDEO = 1 << 1,
  BOTH = AUDIO | VIDEO,
}

/**
 * 共享content采集类型
 * 
 * @param SCREEN 屏幕
 * @param APP APP
 * @param ONLINE 网络视频源
 * @param MEDIA_FILE 媒体文件
 * @param CAMERA 本地摄像头
 * @param INVALID 不可用
 */
export enum ContentCaptureType {
  SCREEN,
  APP,
  ONLINE,
  MEDIA_FILE,
  CAMERA,
  INVALID,
}

/**
 * 滤镜类型
 * 
 * @param NONE 无效果
 * @param CONCISE 简洁
 * @param NATURAL 自然
 * @param EXQUISITE 精致
 * @param PEACEFUL 宁静
 * @param SOFT 柔和
 * @param LIGHT_LUXURY 轻奢
 * @param YOUTH 青春
 * @param RAIN 雨后
 * @param CAMPUS 校园
 * @param WARMTH 热情
 * @param REFRESHING 清新
 * @param GALAXY 银河
 * @param PURE 清澈
 * @param DAWN 清晨
 * @param DREAM 梦幻
 * @param HIGHLIGHT 高光
 * @param ELEGANT 典雅
 * @param NOSTALGIA 怀旧
 * @param DARK 暗调
 * @param RETRO 老电影
 */
export enum VideoFilterStyle {
  NONE,
  CONCISE,
  NATURAL,
  EXQUISITE,
  PEACEFUL,
  SOFT,
  LIGHT_LUXURY,
  YOUTH,
  RAIN,
  CAMPUS,
  WARMTH,
  REFRESHING,
  GALAXY,
  PURE,
  DAWN,
  DREAM,
  HIGHLIGHT,
  ELEGANT,
  NOSTALGIA,
  DARK,
  RETRO,
}

/**
 * 美颜类型
 * 
 * @param NONE 无效果
 * @param SMOOTH 磨皮
 * @param WHITEN 美白
 * @param BLUSH 红润
 */
export enum VideoBeautyStyle {
  NONE,
  SMOOTH,
  WHITEN,
  BLUSH,
}

/**
 * 虚拟背景模式
 * 
 * @param NONE 无效果
 * @param BG_BLUR 背景虚化
 * @param BG_IMAGE 自定义图片
 */
export enum VirtualBgMode {
  NONE,
  BG_BLUR,
  BG_IMAGE,
}

/**
 * imageRender 支持的数据类型
 * 
 * @param IMG 对应 string 和 HTMLImageElement
 * @param RGBA24 对应 ArrayBuffer 或 UintArray
 * @param IMAGE_DATA 对应 ImageData 数据
 * @param RGBA 对应 ArrayBuffer 或 UintArray
 * @param ARGB 对应 ArrayBuffer 或 UintArray
 */
export enum ImageRenderDataType {
  IMG,
  RGBA24,
  IMAGE_DATA,
  RGBA,
  ARGB,
}

/**
 * 代理类型
 * 
 * @param None 无代理
 * @param HTTP HTTP代理 - http、wss...
 * @param UDP  UDP代理 - media
 * @param SOCK5  SOCKS代理 (V4 or V5) 类型
 */
export enum XYProxyType {
  None,   
  HTTP,   
  UDP,  
  SOCK5,
};
